$bog_smalljs_docs $mol_view
	page \introduction
	page_md \
	title_text \
	edit_uri \
	sidebar_open? false
	attr *
		bog_smalljs_sidebar_open <= sidebar_open
	auto /
		<= scroll_reset null
	sub /
		<= Menu_toggle $mol_button_minor
			click? <=> menu_toggle? null
			sub /
				<= Menu_icon $mol_icon_menu
				<= Menu_label $mol_view
					sub / <= title_text
		<= Sidebar $mol_view
			sub <= sidebar_groups /
		<= Main $mol_view
			sub /
				<= Body $bog_smalljs_text
					text <= page_md
				<= Edit $mol_link
					uri <= edit_uri
					sub /
						<= Edit_icon $mol_icon_pencil
						<= Edit_label @ \Edit this page on GitHub
				<= Feedback $mol_view
					sub <= feedback_content /
				<= Nav $mol_view
					sub <= nav_links /
		<= Toc $mol_view
			sub /
				<= Toc_title $mol_view
					sub / <= toc_title_text @ \On this page
				<= Toc_list $mol_view
					sub <= toc_links /
	Group* $mol_view
		sub <= group_content* /
	Group_title* $mol_view
		sub / <= group_title_text* \
	Link* $mol_link
		arg <= link_arg* *
		event_click? <=> nav_click? null
		sub / <= link_title* \
	Toc_link* $mol_link
		arg <= toc_arg* *
		sub / <= toc_text* \
	Feedback_prompt $mol_view
		sub / <= feedback_prompt_text @ \Was this helpful?
	Feedback_yes $mol_button_minor
		click? <=> feedback_yes? null
		sub /
			<= Feedback_yes_icon $mol_icon_thumb_up
			<= feedback_yes_label @ \Yes
	Feedback_no $mol_button_minor
		click? <=> feedback_no? null
		sub /
			<= Feedback_no_icon $mol_icon_thumb_down
			<= feedback_no_label @ \No
	Feedback_thanks $mol_view
		sub / <= feedback_thanks_text @ \Thanks for the feedback!
	Prev $mol_link
		arg <= prev_arg *
		sub /
			<= Prev_hint $mol_view
				sub / <= prev_hint_text @ \Previous
			<= Prev_title $mol_view
				sub / <= prev_title \
	Next $mol_link
		arg <= next_arg *
		sub /
			<= Next_hint $mol_view
				sub / <= next_hint_text @ \Next
			<= Next_title $mol_view
				sub / <= next_title \
